import React from "react";
import SomethingWentWrong from "../SomethingWentWrong/SomethingWentWrong";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="text-center py-5 m-5">
          <SomethingWentWrong />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
